module.exports = __webpack_public_path__ + "img/entertainment.aa4179c5.svg";